import { render, staticRenderFns } from "./BreadTabulator.vue?vue&type=template&id=96707ada&"
import script from "./BreadTabulator.vue?vue&type=script&lang=js&"
export * from "./BreadTabulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports